export default __webpack_public_path__ + "static/media/error404.2484588d.svg";